import { featureCards } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-sm font-label font-semibold text-primary-500 mb-2 tracking-wider uppercase">
            Why Choose Us
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            프리미엄허브만의 <span className="text-primary-500">특별한 서비스</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-label">
            복잡한 절차 없이, 빠르고 간편하게 대출을 받아보세요.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureCards.map((card, index) => (
            <div
              key={card.id}
              className="group bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:shadow-lg"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-50 flex items-center justify-center mb-5 md:mb-6 group-hover:bg-primary-500 transition-colors duration-300">
                <i
                  className={`${card.icon} w-7 h-7 md:w-8 md:h-8 flex items-center justify-center text-primary-500 group-hover:text-white transition-colors duration-300 text-xl md:text-2xl`}
                />
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3">
                {card.title}
              </h3>
              <p className="text-sm text-foreground-600 font-label leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}